import {
  GlobalExclusion,
  GlobalExclusionCreate,
} from '@/features/operations/components/pages/Programs/ProgramView/constant'
import { SearchParams } from '@/types'
import {
  AutoUpdateWaterBudget,
  CreateProgram,
  Program,
  ProgramRunHistory,
  RunTime,
  UpdateGlobalExclusion,
  UpdateProgram,
  UpdateProgramEnable,
  UpdateProgramRun,
  IPayloadFetchET24h,
} from '@/types/program'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const programApi = {
  getById(searchParams: SearchParams = {}) {
    const url = `api/program`
    return axiosClient.get(url + queryStringify(searchParams))
  },
  getDetail(id: number, interfaceId: number) {
    const url = `api/program/${interfaceId}/${id}`
    return axiosClient.get<Program>(url)
  },

  getValidationProgram(programId: number, interfaceId: number) {
    const url = `api/simulation/validate-program?interfaceId=${interfaceId}&programId=${programId}`
    return axiosClient.get(url)
  },

  getOverlappingProgram(programId: number, interfaceId: number) {
    const url = `api/program/check-overlapping-program?interfaceId=${interfaceId}&programId=${programId}`
    return axiosClient.get(url)
  },

  getGlobalExclusion(interfaceId: number) {
    const url = `api/globalexclusiontime/${interfaceId}`
    return axiosClient.get<GlobalExclusion[]>(url)
  },

  getProgramRunHistory(interfaceId: number, programId: number) {
    const url = `api/v2/historylog/run-history`
    return axiosClient
      .get(url + queryStringify({ interfaceId, programId, pageSize: 0 }))
      .then((res) => ({
        data: res.data.data,
      }))
  },
  getAllocWater(
    interfaceId: number,
    etReferenceId: number,
    landscapeArea: number,
    waterAllocation: number,
  ) {
    const url = `api/program/allocpercent?interfaceId=${interfaceId}&etReferenceId=${etReferenceId}&landscapeArea=${landscapeArea}&waterAllocation=${waterAllocation}`
    return axiosClient.get<Program>(url)
  },

  createRunTime(payload: RunTime) {
    const url = '/api/program/runtime'
    return axiosClient.post(url, payload)
  },

  autoUpdateWaterBudgetCreate(payload: AutoUpdateWaterBudget) {
    const url = '/api/program/auto-update-water-budget-create-program'
    return axiosClient.post(url, payload)
  },

  autoUpdateWaterBudgetUpdate(programId: number, interfaceId: number) {
    const url = `/api/simulation/auto-update-water-budget-program-not-completed?programId=${programId}&interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  createETTime(payload: IPayloadFetchET24h) {
    let url = `/api/program/fetch-et`
    return axiosClient.post(url, payload)
  },

  create(payload: CreateProgram) {
    const url = '/api/program'
    return axiosClient.post(url, payload)
  },

  createGlobalExclusion(payload: GlobalExclusionCreate) {
    const url = '/api/globalexclusiontime'
    return axiosClient.post(url, payload)
  },

  update(payload: UpdateProgram) {
    const url = '/api/program'
    return axiosClient.put(url, payload)
  },

  updateGlobalExclusion(payload: UpdateGlobalExclusion) {
    const url = '/api/globalexclusiontime'
    return axiosClient.put(url, payload)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/program/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },

  deleteGlobalExclusion(interfaceId: string, id: string) {
    const url = `/api/globalexclusiontime/${interfaceId}/${id}`
    return axiosClient.delete(url)
  },

  updateRun(data: UpdateProgramRun) {
    const url = '/api/program/run'
    return axiosClient.put(url + queryStringify(data))
  },
  updateEnable(data: UpdateProgramEnable) {
    const url = '/api/program/enable'
    return axiosClient.put(url + queryStringify(data))
  },
}

export default programApi
